import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { AuthService, User } from '@auth0/auth0-angular';
import { Subscription } from 'rxjs';

import { LanguageService, SegmentService } from 'services';
import { AutoUnsubscribe, getSupportEmail } from 'helpers';
import { SelectedOrganization } from 'src/app/authentication/signup/types';
import { InvitationService } from '../../../../invite/invitation.service';

@Component({
    selector: 'fc-organization-exists',
    templateUrl: './organization-exists.component.html',
    styleUrls: ['./organization-exists.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    providers: [InvitationService]
})
@AutoUnsubscribe
export class OrganizationExistsComponent implements OnInit {
    @Input()
    organization: SelectedOrganization;
    @Input() isReferral: boolean;

    @Output()
    backClicked = new EventEmitter<void>();

    @Output()
    finishRequestClicked = new EventEmitter<unknown>();

    public supportEmail = getSupportEmail();

    subscription = new Subscription();

    private _loggedInUser: User;

    constructor(
        private invitationService: InvitationService,
        private languageService: LanguageService,
        private segmentService: SegmentService,
        private authService: AuthService
    ) {}

    ngOnInit() {
        this.subscription.add(
            this.authService.user$.subscribe((user) => {
                this._loggedInUser = user;
            })
        );
    }

    sendTeamInviteRequest() {
        this.subscription.add(
            this.invitationService
                .requestTeamInvite({
                    organizationId: this.organization._id,
                    firstName: this._loggedInUser.given_name,
                    lastName: this._loggedInUser.family_name,
                    email: this._loggedInUser.email,
                    preferredLanguage: this.languageService.getCurrentLanguage()
                })
                .subscribe({
                    next: () => {
                        this.trackSignupExistingOrganization();
                        this.finishRequestClicked.emit();
                    },
                    error: (error) => {
                        this.finishRequestClicked.emit(error);
                    }
                })
        );
    }

    private trackSignupExistingOrganization() {
        const eventName = '[Signup] team invite requested';

        const eventPayload = {
            orgType: this.organization.type === 'manufacturer' ? 'brand' : this.organization.type,
            signupType: this.isReferral ? 'referral' : 'normal Signup',
            receivingOrgName: this.organization.name
        };

        this.segmentService.track(eventName, eventPayload);
    }
}
